import { Paper, Typography } from '@mui/material';

export const NotFoundPage = () => (
  <Paper sx={{ p: 4, textAlign: 'center' }} variant="outlined">
    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Page not found</Typography>
    <Typography color="text.secondary" sx={{ mt: 0.5 }} variant="body2">
      The page you&apos;re looking for doesn&apos;t exist.
    </Typography>
  </Paper>
);
